import React, { useState, useEffect, useContext } from "react";
import './ViewProjectInfo.css'
import DropDown from "../../../../../DropDown/DropDown";
import { Form } from "react-bootstrap";
import { FaSave } from "react-icons/fa";
import { AiFillEdit } from "react-icons/ai";
import { MdCancel, MdEdit } from "react-icons/md";
import ProjectAPIs from "../../../../../../MasonyFixingsAPIs/ProjectAPIs/ProjectAPIs";
import { useNavigate, useParams } from "react-router-dom";
import { format } from 'date-fns';
import { useToast } from "../../../../../../Contexts/ToastContext";
import { FetchProjectContext, ProjectDataContext } from "../ViewProject";
import LookupAPIs from "../../../../../../MasonyFixingsAPIs/LookupAPIs/LookupAPIs";
import ApiResponseHandler from "../../../../../../MasonyFixingsAPIs/ApiResponseHandler";

export default function ViewProjectInfo() {

    const { addToast } = useToast();

    const projectContext = useContext(ProjectDataContext);
    const getProjectTitleInfo = useContext(FetchProjectContext);

  const params = useParams();
  const navigate = useNavigate();

//   const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [sending, setSending] = useState(false);

  const [categories, setCategories] = useState([]);
  const [sectors, setSectors] = useState([]);

  const [projectData, setProjectData] = useState({
    title: projectContext.name,
    cisID: projectContext.cis_id,
    applicant: projectContext.applicant,
    catID: projectContext.category_id,
    sectorID: projectContext.sector_id,
    desc: projectContext.building_description,
    footprint: projectContext.footprint,
    startDate: format(new Date(projectContext.start_date), 'yyyy-MM-dd'),
    endDate: format(new Date(projectContext.end_date), 'yyyy-MM-dd')
  });

//   const getProjectTitleInfo = (id) => {
//     ProjectAPIs.GetProjectTitleInfo(id)
//       .then((response) => {
//         if (response.status === 200) {
//           const data = response.data;
//           setProjectData({
//             title: data.name,
//             cisID: data.cis_id,
//             applicant: data.applicant,
//             catID: data.category_id,
//             sectorID: data.sector_id,
//             desc: data.building_description,
//             footprint: data.footprint,
//             startDate: format(new Date(data.start_date), 'yyyy-MM-dd'),
//             endDate: format(new Date(data.end_date), 'yyyy-MM-dd')
//           });
//           setLoading(false);
//           setEditing(false);
//         }
//       })
//       .catch((err) => {
//         console.log(err);
//         if (err.response?.status === 401) {
//           if (err.response.data.logout) navigate('/login');
//           else window.alert(err.response.data.message);
//         }
//       });
//   }

  useEffect(() => {
    getProjectTitleInfo(params.ProjectID)
  }, [params.ProjectID]);

  useEffect(() => {
    setProjectData({
    title: projectContext.name,
    cisID: projectContext.cis_id,
    applicant: projectContext.applicant,
    catID: projectContext.category_id,
    sectorID: projectContext.sector_id,
    desc: projectContext.building_description,
    footprint: projectContext.footprint,
    startDate: format(new Date(projectContext.start_date), 'yyyy-MM-dd'),
    endDate: format(new Date(projectContext.end_date), 'yyyy-MM-dd')
  })
  }, [projectContext])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProjectData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleEdit = () => {
    setSending(true);
    const putJSON = {
      name: projectData.title,
      cis_id: projectData.cisID,
      applicant: projectData.applicant,
      category_id: projectData.catID,
      sector_id: projectData.sectorID,
      building_description: projectData.desc,
      footprint: projectData.footprint,
      start_date: projectData.startDate,
      end_date: projectData.endDate
    };

    ProjectAPIs.PutProjectTitleInfo(params.ProjectID, putJSON)
      .then((response) => {
        if (response.status === 200) {
          getProjectTitleInfo(params.ProjectID);
          addToast({ message: "Details updated successfully!", variant: "success", autoHide: true });
          setSending(false);
          setEditing(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setSending(false);
        if (err.response?.status === 401) {
          if (err.response.data.logout) navigate('/login');
          else window.alert(err.response.data.message);
        }
      });
  }

  const getCategories = () => {
    LookupAPIs.GetCategory()
    .then((response) => {
        setCategories(response.data);
    })
    .catch((err) => {
        ApiResponseHandler(err.response, navigate);
    })
    
  }

  const getSectors = () => {
    LookupAPIs.GetSector()
    .then((response) => {
        setSectors(response.data);
    })
    .catch((err) => {
        ApiResponseHandler(err.response, navigate);
    })
    
  }

  const handleCancel = () => {
    setEditing(false);
    getProjectTitleInfo(params.ProjectID);
  }

  useEffect(() => {
    getCategories();
    getSectors();
  }, [])

  return (
    <div className="project-section">

      {/* Actions */}
      <div className="project-section-header">
      <div className="project-header-actions">
        {editing ? (
          <>
            <button disabled={sending} type={"submit"} className="save-btn" onClick={handleEdit}>Save</button>
            <button disabled={sending} type={"button"} className="cancel-btn" onClick={handleCancel}>Cancel</button>
          </>
        ) : (
          <button className="edit-btn" onClick={() => setEditing(true)}><MdEdit /> Edit</button>
        )}
      </div>
      </div>

    

      {/* Building Description */}
      <div className="project-section-body-item">
        <strong className="label">Building Description:</strong>
        </div>
        <div className="m-1">
        {editing ? (
          <><Form.Control
            as="textarea"
            rows={3}
            name="desc"
            value={projectData.desc}
            onChange={handleChange}
            disabled={sending}
            className="editable-field"
            maxLength={6000}
          />
          <div className='buidling-description-limit'>{projectData.desc.length}/6000</div>
          </>
        ) : (
          <p className="building-description">{projectData.desc}</p>
        )}
      </div>

      {/* Details Grid */}
      <div className="project-section-body">

        {editing ? 
        <div className="project-section-body-item">
          <strong className="label">Promoter:</strong>
          
            <Form.Control size="sm" name="applicant" value={projectData.applicant} onChange={handleChange} disabled={sending} className="editable-field" />
        </div>
        :
            <div className="project-section-body-item">
                    <span className="label">Promoter:</span>
                    <span>{projectContext.applicant}</span>
            </div>
        }


        {editing ? 
        <div className="project-section-body-item">
          <strong className="label">Category</strong>
          <DropDown.Category
            value={projectData.catID}
            onChange={(e) => handleChange({ target: { name: "catID", value: e.target.value } })}
            disabled={!editing || sending}
            size="sm"
          />
        </div>
        :
            <div className="project-section-body-item">
                    <span className="label">Category:</span>
                    <span>{categories.find((c) => c.id == projectContext.category_id)?.name ?? ''}</span>
            </div>
        }

        {editing ? 
        <div className="project-section-body-item">
          <strong className="label">Sector</strong>
          <DropDown.CategorySectors
            categoryID={projectData.catID}
            value={projectData.sectorID}
            onChange={(e) => handleChange({ target: { name: "sectorID", value: e.target.value } })}
            disabled={!editing || sending}
            size="sm"
          />
        </div>
        :
            <div className="project-section-body-item">
                    <span className="label">Sector:</span>
                    <span>{sectors.find((s) => s.id == projectContext.sector_id)?.name ?? ''}</span>
            </div>
        }

        {editing ? 
        <div className="project-section-body-item">
          <strong className="label">Footprint</strong>
          
            <Form.Control size="sm" name="footprint" value={projectData.footprint} onChange={handleChange} disabled={sending} className="editable-field" />
        </div>
        :
        <div className="project-section-body-item">
                    <span className="label">Footprint:</span>
                    <span>{projectData.footprint} m<sup>2</sup></span>
            </div>
        }
      </div>


      
    </div>
  );
}